import styled from 'styled-components';
import { DataGrid } from '../../../ui-toolkit';

export const FeeTable = styled(DataGrid)`
  th {
    padding-right: ${(props) => props.theme.spacing.spacing5};
    padding-left: ${(props) => props.theme.spacing.spacing5};
    padding-top: 0;
    vertical-align: bottom;
    text-align: end !important;
    * {
      white-space: pre-line !important;
      padding-top: 0;
    }
  }
  tr th:first-child {
    width: 40%;
    text-align: start !important;
    vertical-align: top;
    padding: 0;
  }
  tr th:last-child {
    vertical-align: top;
  }
  tr td:not(:first-child) {
    padding-right: ${(props) => props.theme.spacing.spacing5};
    padding-left: ${(props) => props.theme.spacing.spacing5};
    text-align: end !important;
  }
  tr th:nth-child(3),
  tr td:nth-child(3) {
    border-right: 1px solid ${(props) => props.theme.colors.gray};
  }
  tr th:nth-child(6),
  tr td:nth-child(6) {
    border-left: 1px solid ${(props) => props.theme.colors.gray};
  }
`;
